import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AutoresponderComponent } from 'src/app/components/autoresponder/autoresponder.component';
import { ChannelSelectorModule } from 'src/app/components/channel-selector/channel-selector.module';
import { SupportStepsModule } from 'src/app/components/support-steps/support-steps.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminWidgetRoutingModule } from './admin-widget-routing.module';
import { AdminWidgetComponent } from './admin-widget.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminWidgetRoutingModule,
    NgxDatatableModule,
    SharedPipesModule,
    SupportStepsModule,
    NgxTippyModule,
    ColorPickerModule,
    ChannelSelectorModule,
    AutoresponderComponent,
  ],
  declarations: [AdminWidgetComponent],
})
export class AdminWidgetModule {}
